import CONFIG from 'Config/settings';
import {
  transformFields,
  transformValues
} from './DaumPostalServiceTransformers';

export default class DaumPostalServiceClient {
  constructor() {
    this.addressFieldMap = CONFIG.ADDRESS_AUTOCOMPLETE.FIELD_MAP;
  }

  init = captureCallback => {
    if (!window?.daum?.Postcode) {
      // eslint-disable-next-line no-console
      console.warn('DaumPostalServiceClient is not available');
      return;
    }

    new window.daum.Postcode({
      oncomplete: result => {
        const fieldsTransformed = transformFields(result, this.addressFieldMap);
        const valuesTransformed = transformValues(fieldsTransformed);
        captureCallback(valuesTransformed);
      }
    }).open();
  };
}
